<script lang="ts" setup>
const { online } = defineProps<{
  online: boolean
}>()

const { signOut, user } = useAuth()

const isOpen = ref<boolean>(false)

const icon = computed(() => {
  if (!online) {
    return 'i-mingcute-device-line'
  }
  return 'i-mingcute-cloud-line'
})

function handleSignOut() {
  signOut()
  isOpen.value = false
}
</script>

<template>
  <UPopover>
    <UButton
      variant="ghost"
      color="neutral"
      class="text-inverted"
      size="xl"
      :icon="icon"
      :aria-label="$t('sync.sync')"
    />
    <template #content>
      <div v-if="online" class="space-y-4 max-w-xs">
        <p>{{ $t('auth.connected') }}</p>
        <p class="text-neutral-700 dark:text-neutral-400">
          {{ $t('sync.online_description') }}
        </p>
        <UButton
          :label="$t('auth.logout')"
          color="neutral"
          icon="i-mingcute-exit-line"
          variant="outline"
          class="w-full"
          size="xl"
          @click="handleSignOut"
        />
      </div>
      <div v-else class="space-y-4 max-w-xs">
        <p class="text-neutral-700 dark:text-neutral-400">
          {{ $t('sync.offline_description') }}
        </p>
        <UButton
          :label="$t('sync.sync_data')"
          color="primary"
          icon="i-mingcute-refresh-4-line"
          class="w-full"
          size="xl"
          to="/auth"
        />
      </div>
    </template>
  </UPopover>
</template>
